<template>
	<panel-wrapper :content-class="['box-wap']">
		<template slot="name">
			推流与录制功能
		</template>
		<div :class="['box-wap-box','button-grid', 'has-per-row-1', 'overflow-y-auto','stream-box']">
			<DangerousButton
				:vibrate="true"
				:sText='streamingText'
				@click="setStreaming({status: !streaming})"
			>
				<!-- 推流状态: {{ streamingText}} -->
				<!-- {{?'':(streamingText == 's')}} -->
				<span v-if="streamingText == 'Offline'">
					推流状态：离线中
				</span>
				<span v-else-if="streamingText == 'starting'">
					开始推流
				</span>
				<span v-else-if="streamingText == 'stopping'">
					推流状态：停止中
				</span>
				<span v-else>
					推流中：{{streamingText}}
				</span>
			</DangerousButton>
			<DangerousButton

				:vibrate="true"
				:sText='recordingText'
				@click="setRecording({status: !recording})"
			>
				{{ recordingText == 'Disabled'?'录制状态：未录制':(recordingText == 'stopping'?'录制状态：停止中':(recordingText != undefined?'录制中：'+recordingText:'开始录制'))}}
			</DangerousButton>
			
			<div class="background-content" v-if='showimgTitles'>
				推 流<br>
				录 制 
				
			</div>
			
		</div>
	</panel-wrapper>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'

import DangerousButton from '../dangerous-button'
import panelMixin from '@/mixins/panel'

export default {
	components: {
		DangerousButton
	},
	mixins: [panelMixin],
	computed: {
		...mapState(['showimgTitles']),
		...mapState('obs', {
			recording: state => state.stream.recording,
			recTimecode: state => state.stream.recTimecode,
			streaming: state => state.stream.streaming,
			streamTimecode: state => state.stream.streamTimecode
		}),
		...mapGetters('obs', ['recordingText', 'streamingText'])
	},
	methods: {
		...mapActions('obs', {
			setRecording: 'stream/recording',
			setStreaming: 'stream/streaming'
		})
	}
}
</script>

<style type="text/css">
	
</style>
